import { render, staticRenderFns } from "./AutomationWorkflows.vue?vue&type=template&id=282b5752&"
import script from "./AutomationWorkflows.vue?vue&type=script&lang=js&"
export * from "./AutomationWorkflows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports